module.exports = __webpack_public_path__ + "media/10.df21ad65.mp3";